"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClayPortal = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var ClayPortalContext = _react.default.createContext(null);

ClayPortalContext.displayName = 'ClayPortalContext';

var ClayPortal = function ClayPortal(_ref) {
  var children = _ref.children,
      containerRef = _ref.containerRef,
      subPortalRef = _ref.subPortalRef;

  var parentPortalRef = _react.default.useContext(ClayPortalContext);

  var portalRef = _react.default.useRef(typeof document !== 'undefined' ? document.createElement('div') : null);

  _react.default.useEffect(function () {
    var closestParent = parentPortalRef && parentPortalRef.current ? parentPortalRef.current : document.body;
    var elToMountTo = containerRef && containerRef.current ? containerRef.current : closestParent;

    if (elToMountTo && portalRef.current) {
      elToMountTo.appendChild(portalRef.current);
    }

    return function () {
      if (elToMountTo && portalRef.current) {
        elToMountTo.removeChild(portalRef.current);
      }
    };
  }, [containerRef, parentPortalRef]);

  var content = _react.default.createElement(ClayPortalContext.Provider, {
    value: subPortalRef ? subPortalRef : portalRef
  }, children);

  return portalRef.current ? (0, _reactDom.createPortal)(content, portalRef.current) : content;
};

exports.ClayPortal = ClayPortal;